module.exports = __webpack_public_path__ + "img/current-location-icon.55871342.svg";